module.exports = __webpack_public_path__ + "img/live-panel-white.a7177bae.svg";